import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {maintenanceVaild} from "../../../components/commonmethod/CommonMethod";
import Th_title from "../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {saveIncident} from "../../../api/maintenance/IncidentService";
import {useDispatch, useSelector} from "react-redux";
import {inspectionRequestCode, useSla} from "../inspection/InspectionCreate";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {CacheType, CodeSpecNum} from "../../../constant/CodeSpecNum";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import Selector from "../../../components/selector/Selector";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";
import {
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvReadOnly,
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

export const incidentType = [
    {value: "자산 장애", text: "자산 장애"},
    {value: "복합 장애", text: "복합 장애"}
];

export const incidentLevel = [
    {id: "1등급", name: "1등급"},
    {id: "2등급", name: "2등급"},
    {id: "3등급", name: "3등급"},
    {id: "4등급", name: "4등급"},
    {id: "5등급", name: "5등급"}
];

export const incidentAcceptCode = [
    {id: "고객 Call", name: "고객 Call"},
    {id: "운영 Call", name: "운영 Call"},
    {id: "현업 Call", name: "현업 Call"},
    {id: "모니터링", name: "모니터링"},
    {id: "기타", name: "기타"}
];

function IncidentCreate() {
    const dispatch = useDispatch();
    const refreshCache = useCacheRefresh();
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [incident, setIncident] = useState({
        incidentType: "자산 장애", useSla: true, requester: user, inspector: user
    });
    const [assets, setAssets] = useState([]);
    const [docs, setDocs] = useState([]);
    const [handler, setHandler] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const requireds = ["incidentType", "requester", "incidentCode", "incidentStartDate", "incidentEndDate", "title", "useSla", "inspector"];

    const create = async () => {
        if (incident.incidentType === "자산 장애" && assets.length === 0) {
            alert("자산을 선택해주세요");
            return false;
        }

        if (!maintenanceVaild(handler, incident, requireds)) return;

        dispatch(apiLoading(true));

        const docFile = [];
        docs.forEach(each => docFile.push(each.object));

        const updatedData = {
            ...incident,
            incidentCode: {id: incident.incidentCode.id},
            inspector: {id: incident.inspector.id},
            requester: {id: incident.requester.id}
        };

        const assetData = incident.incidentType === "자산 장애" ? assets : undefined;

        await saveIncident(updatedData, assetData, handler, docFile).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.");
                refreshCache(CacheType.INCIDENT);
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/maintenance/incident/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/maintenance/incident", {state: {test: location.state}});
                }
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    useEffect(() => {
        setAssets([]);
        if (incident.incidentType === "복합 장애") {
            setIncident((prev) => {
                const updateData = {...prev};
                if (updateData.required_validate) {
                    updateData.required_validate.assets = true;
                }
                return updateData;
            });
        }
    }, [incident.incidentType]);

    const requestInfoPanel = (
        <DetailPanel title="장애요청정보">
            <DetailKvTable>
                <tbody>
                {incident.incidentType === "자산 장애" && (
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth>
                            <UserSelectionField
                                layout="inline"
                                data={assets}
                                countUnit="개"
                                chipEntity="asset"
                                listModalTitle="자산목록"
                                onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                            >
                                <SearchSelector
                                    auth
                                    multiSelect
                                    variant="compact"
                                    entity="maintenance-assets"
                                    uniqueKey="assets"
                                    data={assets}
                                    onChange={(v) => {
                                        if (v?.__multiFlat) setAssets(v.__multiFlat);
                                    }}
                                >
                                    <SimmsInputSearch type="TEXT"/>
                                    <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                    <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                    <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                    <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive/>
                                    <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                    <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                                </SearchSelector>
                            </UserSelectionField>
                        </Th_title>
                    </tr>
                )}
                <tr>
                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                    <DetailKvReadOnly label="등록자" value={user.name}/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="수정일시" value=""/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title="장애 제목" colspan={3} className="fieldset-td" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setIncident, "title", v, true)} data={incident.title}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="요청자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setIncident, "requester", incident.requester, v)}
                            data={incident.requester}
                            entity="userAccount"
                            uniqueKey="requester"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="장애유형" colspan={1} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setIncident, "incidentCode", incident.incidentCode, v)}
                            data={incident.incidentCode}
                            entity="code"
                            parentKey={CodeSpecNum.IncidentRequestCode}
                            recursive
                        />
                    </Th_title>
                    <Th_title title="요청방식" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate
                            target="incidentRequest"
                            options={inspectionRequestCode}
                            data={{data: incident, fnc: setIncident}}
                            defaultValue={incident.incidentRequest}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="장애인지" colspan={1} className="fieldset-td" auth>
                        <div className="flex items-center gap-1 w-full min-w-0">
                            <SelectComboBoxForCreate
                                target="incidentAcceptCode"
                                options={incidentAcceptCode}
                                data={{data: incident, fnc: setIncident}}
                                defaultValue={incident.incidentAcceptCode}
                            />
                            <SimmsInput
                                onChange={(v) => inputOnChange(setIncident, "incidentAcceptText", v, false)}
                                data={incident.incidentAcceptText}
                                style={{flex: "1 1 auto", minWidth: 0, width: "auto"}}
                            />
                        </div>
                    </Th_title>
                    <Th_title title="장애등급" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate
                            target="incidentLevel"
                            options={incidentLevel}
                            data={{data: incident, fnc: setIncident}}
                            defaultValue={incident.incidentLevel}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="장애구분" colspan={3} className="fieldset-td" required auth>
                        <SimmsRadio
                            options={incidentType}
                            onChange={(v) => inputOnChange(setIncident, "incidentType", v, true)}
                            data={incident.incidentType}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="장애기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                        <div className="web-flex asset-detail-date-range">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setIncident, "incidentStartDate", v, true)}
                                data={incident.incidentStartDate}
                                time
                                constraint={{lessThan: incident.incidentEndDate && dayjs(incident.incidentEndDate), required: true}}
                                auth
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setIncident, "incidentEndDate", v, true)}
                                data={incident.incidentEndDate}
                                time
                                constraint={{largerThan: incident.incidentStartDate && dayjs(incident.incidentStartDate), required: true}}
                                auth
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="장애내용" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setIncident, "incidentContent", v, false)} data={incident.incidentContent} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="SLA 사용여부" className="fieldset-td" colspan={3} required auth>
                        <SimmsRadio
                            options={useSla}
                            onChange={(v) => inputOnChange(setIncident, "useSla", v, true)}
                            data={incident.useSla}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="비고" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setIncident, "etc", v, false)} data={incident.etc} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const statusPanel = (
        <DetailPanel title="장애 요청 진행상태">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={handler}
                            onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="userAccount"
                                uniqueKey="handler"
                                data={handler}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setHandler(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="검수자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setIncident, "inspector", incident.inspector, v)}
                            data={incident.inspector}
                            entity="userAccount"
                            uniqueKey="inspector"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const filePanel = (
        <DetailFilePanel
            title="첨부"
            isEditing
            pendingFiles={{files: docs, setFiles: setDocs}}
            pendingInputId="incident_create_doc"
        />
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="장애 등록"
            meta="신규 장애 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/maintenance/incident")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={statusPanel}
                        aside={filePanel}
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {IncidentCreate};
